import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { pasoSolicitud, trackEvent } from "../../../services/analytics/track";

import { useNavigate } from "react-router-dom";

import { ProgressBarComponent } from "../../../components/new_components/progressBar";

import { ReactComponent as GalileIcon } from "../../../public/logos/galilea-icono.svg";
import DatosPersonalesForm from "./DatosPersonalesForm";
import DatosOfertaForm from "./DatosOfertaForm";
import BienvenidoPage from "./BienvenidoPage";
import DatosOtp from "./DatosOtp";
import AnimationComponent from "../../../components/new_components/animation";
import finishSound from "./../../../public/sounds/nave_aterrizando.mp3";
import { stepsCreditStore } from "../../../store/creditStore/stepsCreditStore";
import FloatingWhatsApp from "../../../components/new_components/FloatingWhatsApp";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { setDataToLocalStorage } from "../helpers/helper";
import { handleValidateUserHasValidCredit } from "../../../utils/creditUser/validateUserHasValidCredit";
import { APIClient } from "../../../helpers/api_helper";
import { GET_AVAILABLE_REWARD } from "../../../helpers/url_helper";
import { HttpRequest } from "../../../services/httpRequest";
import { creditOfferStore } from "../../../store/creditStore/offerCreditStore";
import {
  getBasicInfoVisitor,
  loadInfoUser,
  loadInfoUserAuth,
} from "../../../utils/creditUser/helpers";
import { useCreditStore } from "../../../store/creditStore/creditUserStore";
import { homologateBankNameAccount } from "../../../utils/options_selects";
import { InfoAlert } from "../../../components/alerts/infoAlert";
import { ErrorAlert } from "../../../components/alerts/errorAlert";
import { creditStatus } from "../Utils";
import { AgreeLocations } from "../../../components/new_components/agreeLocations";
import { userBankStore } from "../../../store/creditStore/userBankStore";
import DatosFlowConnectBank from "./DatosFlowConnectBank";
import { AlertProvider } from "./bankFlowSelector/provider/alertProvider";
import { CreditStatusEnum } from "../../../constants/CreditStatusEnum";

const apiClient = new APIClient();

export function CreditoPage() {
  const navigate = useNavigate();
  // Parámetros de la URL capturados una sola vez al montar: la URL se limpia con
  // replaceState y en re-renders posteriores (p. ej. "Reintentar") ya no estarían.
  const [urlParams] = useState(() => {
    const sp = new URL(window.location.href).searchParams;
    return {
      statusCredit: sp.get("statusCredit"),
      creditIdFromApp: sp.get("credit_id"),
      fromapi: sp.get("fromapi"),
      creditIdFromApi: sp.get("creditId"),
      idOperation: sp.get("idOperation"),
      grant: sp.get("grant"),
      documento: sp.get("docUser"),
      transferCode: sp.get("transferCode"),
      transferState: sp.get("transferState"),
    };
  });
  const {
    statusCredit,
    creditIdFromApp,
    fromapi,
    creditIdFromApi,
    idOperation,
    grant,
    documento,
    transferCode,
    transferState,
  } = urlParams;
  const audioRef = useRef(null);
  const starsRef = useRef(null);

  // const newUrl =
  //   window.location.origin + window.location.pathname + window.location.hash;
  // window.history.replaceState({}, document.title, newUrl);

  const { stepCredit, saveSteps, loadSteps, clearSteps } = stepsCreditStore();
  const {
    offerCreditStore,
    saveOfertCredit,
    loadOfertCredit,
    clearOfertCredit,
  } = creditOfferStore();
  const { saveUser, clearUser } = useCreditStore();
  const { clearUserBank } = userBankStore();

  const [messsageAlert, setMessageAlert] = useState("");
  const [alertSession, setAlertSession] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [isOpenInfo, setIsOpenInfo] = useState(false);

  const [, setRewardHistoryAvailable] = useState();
  const [openModalLocation, setOpenModalLocation] = useState(false);

  const [isStepLoading, setIsStepLoading] = useState(fromapi ? true : false);
  const [hiddenIconStart, setHiddenIconStart] = useState(false);
  const [isFinishPass, setIsFinishPass] = useState(false);
  const [apiFlowError, setApiFlowError] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [currentStep, setCurrentStep] = useState(null);
  const [totalSteps] = useState(5);

  const [textIndex, setTextIndex] = useState(0);

  const stepTitles = [
    "Cuéntanos sobre ti.",
    "Revisemos la oferta.",
    "Conecta tu banco.",
    //"Datos del desembolso.",
    "Firmar Documentos.",
  ];

  const [texts, setTexts] = useState([
    "Tu solicitud para seguir tu viaje a Galilea ya está en proceso",
    "Analizando tu comportamiento de pago",
    "Calculando tu capacidad de endeudamiento",
    "Consultando en bases de datos oficiales",
  ]);

  const cleanIndexDB = useCallback(() => {
    clearUser();
    clearUserBank();
    clearOfertCredit();
    clearSteps();
    localStorage.clear();
  }, [clearUser, clearUserBank, clearOfertCredit, clearSteps]);

  const handleStepChange = (nextStep) => {
    // Evitar llamadas redundantes
    if (nextStep === currentStep) return;
    if (nextStep > currentStep) trackEvent("solicitud_paso_completado", pasoSolicitud(currentStep));

    // Paso final (bienvenida)
    if (nextStep === 5) {
      setIsFinishPass(true);

      saveSteps({
        stepInternal: 1,
        stepGeneral: nextStep,
        loading: false,
      });

      setCurrentStep(nextStep);

      setTimeout(() => {
        setIsFinishPass(false);
      }, 11000);

      return;
    }

    if (nextStep === 2 && currentStep !== 3) {
      setIsStepLoading(true);

      const intervalId = setInterval(() => {
        setTextIndex((prev) => (prev + 1) % texts.length);
      }, 3000);

      setTimeout(() => {
        clearInterval(intervalId);
        setIsStepLoading(false);
        setCurrentStep(nextStep);

        saveSteps({
          stepInternal: 1,
          stepGeneral: nextStep,
          loading: false,
        });
      }, 12000);

      return;
    }

    saveSteps({
      stepInternal: 1,
      stepGeneral: nextStep,
      loading: false,
    });

    setCurrentStep(nextStep);
  };

  const AudioPlayer = () => (
    <audio ref={audioRef} src={finishSound} preload="auto" />
  );

  const getContainerStyle = () => {
    if (currentStep === 5) {
      return {
        width: isMobile ? "90vw" : "max(600px, 40vw)",
        height: isMobile ? "auto" : "max(690px, 66vh)",
        minHeight: isMobile ? "70vh" : "500px",
        maxHeight: "95vh",
        position: "fixed", // Fixed es mejor para centrado
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: isMobile ? "20px" : "30px",
        padding: isMobile ? "24px" : "40px",
        margin: 0,
        overflow: "auto",
        boxSizing: "border-box",
        zIndex: 100,
      };
    }

    return {
      width: "-webkit-fill-available",
      height: "-webkit-fill-available",
      backgroundColor: "#29214F",
      left: isMobile ? "20px" : "390px",
      top: "clamp(150px, 6vw, 200px)",
      position: "absolute",
      borderRadius: "30px",
      marginRight: isMobile ? "20px" : "107px",
      marginBottom: "clamp(50px, 3vw, 80px)",
    };
  };

  const handleOpenAlertInfo = (type, message, isOpen) => {
    if (type === "info") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenInfo(isOpen);
    }

    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setAlertSession(isOpen);
    }

    setTimeout(() => {
      setMessageAlert("");
      setAlertSession(!isOpen);
      setIsOpenInfo(!isOpen);
    }, 6000);
  };

  const determineOpenModalLocation = async (e) => {
    const result = await navigator.permissions.query({ name: "geolocation" });
    if (result.state === "granted") {
      navigator.geolocation.getCurrentPosition((position, error) => {
        if (error)
          console.error("No se logró encontrar la posición del usuario");
        localStorage.setItem(
          "coords",
          JSON.stringify({
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          }),
        );
      });
    } else if (result.state === "denied") {
      setOpenModalLocation(true);
    } else if (result.state === "prompt") {
      setOpenModalLocation(true);
    }
  };

  const flowFromApi = async () => {
    let fromapiStorage = localStorage.getItem("fromapi") ?? "";
    const resolvedCreditIdFromApi =
      creditIdFromApi || localStorage.getItem("credit_id");
    if (
      resolvedCreditIdFromApi &&
      (fromapi === "true" || fromapiStorage)
    ) {
      try {
        // La sesión se crea primero: buscar-credito-byid ahora exige sesión.
        let docApi = documento || localStorage.getItem("doc");
        if (!docApi) {
          let data = await loadCreditById(resolvedCreditIdFromApi);
          docApi = data.documento;
        }
        let { message } = await HttpRequest.validateTokenSessionVisitorApi({
          doc: docApi,
          ...(grant ? { grant } : {}),
        });

        setDataToLocalStorage({
          otp: message?.otp,
          documento: message.doc,
          tokenJwt: message.tokenJwt,
          creditId: resolvedCreditIdFromApi,
          typeUser: "client",
          isSignin: true,
          idOperation: idOperation,
        });
        localStorage.setItem("credit_aprobate", true);
        return true;
      } catch (error) {
        console.error("Ocurrió un error al generar token al usuario.");
        console.error(error);
        handleOpenAlertInfo(
          "error",
          `Ocurrió un error al generar la autenticación, intente más tarde.`,
          true,
        );
        setTimeout(() => {
          cleanIndexDB();
          return navigate("/");
        }, 5000);
        return false;
      }
    } else {
      return false;
    }
  };

  const flowFromPendient = async () => {
    let statusStorage = localStorage.getItem("creditStatus") ?? "";
    const currentCreditIdFromApp =
      creditIdFromApp !== null && creditIdFromApp !== undefined
        ? creditIdFromApp
        : localStorage.getItem("credit_id");

    if (
      currentCreditIdFromApp &&
      (statusCredit === creditStatus.PF ||
        statusCredit === creditStatus.S ||
        statusStorage === creditStatus.PF ||
        statusStorage === creditStatus.S)
    ) {
      localStorage.setItem("credit_aprobate", true);
      return true;
    } else {
      return false;
    }
  };

  const handleSetAvailableReward = async () => {
    let availableReward = await getAvailableReward();
    setRewardHistoryAvailable(availableReward);
    return;
  };

  const getAvailableReward = async () => {
    try {
      const doc = documento ?? localStorage.getItem("doc"); // consistente
      if (!doc) return {};
      let { data } = await apiClient.get(`${GET_AVAILABLE_REWARD}${doc}`);
      return data?.data ?? {};
    } catch (error) {
      console.error(error);
      return {};
    }
  };

  const loadCreditById = async (creditId) => {
    try {
      const data = await HttpRequest.getCreditById(creditId);
      return data.message.info;
    } catch (error) {
      console.error(error);
    }
  };

  const resetSession = useCallback(() => {
    localStorage.clear();
    localStorage.setItem("is_signin", false);
    cleanIndexDB();
    navigate("/");
  }, [cleanIndexDB, navigate]);

  const getFlowCredit = () => {
    const statusStorage = localStorage.getItem("creditStatus") ?? "";
    /* const renovarStorage = localStorage.getItem("renovar") ?? ""; */
    const fromapiStorage = localStorage.getItem("fromapi") ?? "";

    if (fromapi || fromapiStorage) {
      setApiFlowError(false);
      setIsStepLoading(true)
      setTexts([]);
      const minTimerPromise = new Promise((resolve) => setTimeout(resolve, 3000));
      flowFromApi().then(async (response) => {
        if (response === true) {
          validateSessionNow().then(async () => {
            try {
              const doc = documento ?? localStorage.getItem("doc");
              let hasValidCredit = await handleValidateUserHasValidCredit(doc);
              if (hasValidCredit === true) {
                return navigate("/micredito");
              }
              await handleSetAvailableReward(doc);
              let data = await loadCreditById(
                localStorage.getItem("credit_id"),
              );
              if (data?.status === "Cancelado") {
                handleOpenAlertInfo(
                  "error",
                  "Lo sentimos, su solicitud ha sido cancelada. Por favor, intente nuevamente o comuníquese con nosotros.",
                  true,
                );
                cleanIndexDB();
                return navigate("/");
              }
              saveOfertCredit(data);
              /* let { isChanges, creditChanges } =
                await validateCreditDatesFromViewOffer(data);
              if (isChanges) {
                saveOfertCredit({ ...offerCreditStore, creditChanges });
              } */

              let infoUserVisitor = await getBasicInfoVisitor(doc);
              localStorage.setItem("phone", infoUserVisitor.phone);
              localStorage.setItem("email", infoUserVisitor.email);
              saveSteps({
                stepInternal: 1,
                stepGeneral: 1,
                loading: true,
              });

              /* updateMyBanksContextFromViewOffer(infoUser, updateMyBanks, myBanks); */
            } catch (error) {
              console.error(error);
              cleanIndexDB();
              return navigate("/");
            }
          });
          await minTimerPromise;
          setIsStepLoading(false)
          setTexts([
            "Tu solicitud para seguir tu viaje a Galilea ya está en proceso",
            "Analizando tu comportamiento de pago",
            "Calculando tu capacidad de endeudamiento",
            "Consultando en bases de datos oficiales",
          ]);
        } else {
          setIsStepLoading(false);
          setApiFlowError(true);
        }
      }).catch((error) => {
        console.error(error);
        setIsStepLoading(false);
        setApiFlowError(true);
      });
      return;
    }

    if (statusCredit || statusStorage) {
      flowFromPendient().then(async (response) => {
        if (response === true) {
          validateSessionNow().then(async () => {
            try {
              let hasValidCredit = await handleValidateUserHasValidCredit(
                localStorage.getItem("doc"),
              );
              if (hasValidCredit === true) {
                return navigate("/micredito");
              }
              await handleSetAvailableReward(localStorage.getItem("doc"));
              let data = await loadCreditById(
                localStorage.getItem("credit_id"),
              );
              if (data?.status === "Cancelado") {
                handleOpenAlertInfo(
                  "error",
                  "Lo sentimos, su solicitud ha sido cancelada. Por favor, intente nuevamente o comuníquese con nosotros.",
                  true,
                );
                cleanIndexDB();
                return navigate("/");
              }
              saveOfertCredit(data);
              /* let { isChanges, creditChanges } =
                await validateCreditDatesFromViewOffer(data);
              if (isChanges) {
                saveOfertCredit({ ...offerCreditStore, creditChanges });
              } */
              let infoUser = await loadInfoUser(localStorage.getItem("doc"));

              let infoUserAuth = await loadInfoUserAuth(
                localStorage.getItem("doc"),
              );
              localStorage.setItem("phone", infoUserAuth.phone);
              saveSteps({
                stepInternal: 1,
                stepGeneral: 2,
                loading: true,
              });

              saveUser({
                ...infoUser,
                statusCredit: statusCredit ? statusCredit : statusStorage,
                bankAccount: homologateBankNameAccount(
                  infoUser.bankAccount,
                  "value",
                ),
              });
              saveOfertCredit({ ...offerCreditStore, infoUserAuth });

              /* updateMyBanksContextFromViewOffer(infoUser, updateMyBanks, myBanks); */
            } catch (error) {
              console.error(error);
              cleanIndexDB();
              return navigate("/");
            }
          });
        } else {
          cleanIndexDB();
          return navigate("/");
        }
      });
      return;
    }
  };

  const validateSessionNow = async () => {
    try {
      let isValidToken = await validateSessionAndJwtToken();
      return isValidToken;
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    // Limpiar la URL de inmediato: documento e id de crédito no deben quedar expuestos
    const newUrl = window.location.origin + window.location.pathname + window.location.hash; window.history.replaceState({}, document.title, newUrl);
    if (fromapi === "true" && creditIdFromApi && idOperation) {
      window.dataLayer = window.dataLayer || [];
      // Sin documento en el dataLayer (credit_id lo usa GTM para atribución)
      window.dataLayer.push({ event: "galilea_attribution_ready", lead_source: "api", credit_id: creditIdFromApi, id_operation: idOperation, });
    }
  }, [fromapi, creditIdFromApi, idOperation]);

  useEffect(() => {
    const loadInitialData = async () => {
      await Promise.all([loadSteps(), loadOfertCredit()]);
    };

    loadInitialData();
  }, [loadSteps, loadOfertCredit]);

  useEffect(() => {
    let fromapiL = fromapi ?? localStorage.getItem("fromapi");
    let statusCreditL = statusCredit ?? localStorage.getItem("creditStatus");
    if (fromapiL || statusCreditL) {
      localStorage.setItem("type_user", "client");
      getFlowCredit();
      return;
    }
    const type_user = localStorage.getItem("type_user");
    if (type_user === "visitor" || type_user === "client") {
      setCurrentStep(1);
      determineOpenModalLocation();
    } else {
      resetSession();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- getFlowCredit intentionally excluded: it's a large unmemoized handler with many nested async dependencies (flowFromApi, flowFromPendient, handleSetAvailableReward, loadCreditById, etc.) that read component state; safely memoizing the whole chain risks stale closures in the credit-application flow. This effect must run once on mount only.
  }, [fromapi, statusCredit, resetSession]);

  useEffect(() => {
    if (!audioRef.current) return;

    let timeoutId;
    const audio = audioRef.current;

    if (isFinishPass) {
      setTimeout(() => {
        audio.pause();
        audio.volume = 0.5;
        audio.muted = false;

        const playPromise = audio.play();
        if (playPromise) {
          playPromise.catch((err) => console.warn("Autoplay bloqueado:", err));
        }

        timeoutId = setTimeout(() => {
          audio.pause();
          audio.currentTime = 0;
          audio.volume = 0;
        }, 4300);
      }, 5000);
    }

    return () => clearTimeout(timeoutId);
  }, [isFinishPass]);

  useEffect(() => {
    if (stepCredit && stepCredit.loading) {
      setCurrentStep(stepCredit.stepGeneral);
      return;
    }
  }, [stepCredit]);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  useEffect(() => {
    const creditAprobate = localStorage.getItem("credit_aprobate");

    if (
      creditAprobate !== null &&
      (creditAprobate === "false" || !creditAprobate)
    ) {
      setHiddenIconStart(false);
      return;
    }

    if (isStepLoading) {
      setHiddenIconStart(false);
    } else {
      const t = setTimeout(() => {
        setHiddenIconStart(true);
      }, 4000);

      return () => clearTimeout(t);
    }
  }, [isStepLoading]);

  useEffect(() => {
    if (transferCode !== null && transferCode !== undefined) {
      localStorage.setItem("transferCode", transferCode);
      localStorage.removeItem("transferState");
    }

    if (transferState !== null && transferState !== undefined) {
      localStorage.setItem("transferState", transferState);
    }
  }, [transferState, transferCode]);

  useEffect(() => {
    let fromapiL = fromapi ?? localStorage.getItem("fromapi");
    if (fromapiL) {
      return;
    }
    const loadCredits = async () => {
      try {
        const data = await HttpRequest.getAllCreditUser(
          localStorage.getItem("doc"),
        );
        const credits = data.message.info;
        if (credits.length > 0) {
          for (let i = 0; i < credits.length; i++) {
            const element = credits[i];
            if (
              element.status === CreditStatusEnum.AD ||
              element.status === CreditStatusEnum.VI
            ) {
              navigate("/micredito");
              return;
            }
          }
        }
        return credits;
      } catch (error) {
        console.log(error);
      }
    };
    loadCredits();
  }, [fromapi, navigate]);

  useEffect(() => {
    const canvas = starsRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let W = 0;
    let H = 0;
    let stars = [];
    let animationId;

    const resize = () => {
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    };

    const createStar = () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      r: Math.random() * 1 + 0.2,
      a: Math.random(),
      da: (Math.random() * 0.005 + 0.001) * (Math.random() < 0.5 ? 1 : -1),
    });

    const init = () => {
      resize();
      stars = Array.from({ length: 160 }, createStar);
    };

    const draw = () => {
      ctx.clearRect(0, 0, W, H);

      for (const star of stars) {
        star.a += star.da;

        if (star.a <= 0.04 || star.a >= 1) {
          star.da *= -1;
        }

        ctx.beginPath();
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${star.a.toFixed(2)})`;
        ctx.fill();
      }

      animationId = requestAnimationFrame(draw);
    };

    window.addEventListener("resize", resize);

    init();
    draw();

    return () => {
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <AlertProvider>
      <Fragment>
        {openModalLocation && (
          <>
            <AgreeLocations
              isOpen={openModalLocation}
              onOpenChange={setOpenModalLocation}
            />
          </>
        )}
        {alertSession && (
          <>
            <InfoAlert
              isOpen={isOpenInfo}
              message={messsageAlert}
              isDesktop={true}
            ></InfoAlert>
            <ErrorAlert
              isOpen={isOpenError}
              message={messsageAlert}
            ></ErrorAlert>
          </>
        )}
        <AudioPlayer />

        {apiFlowError ? (
          <div
            className="fixed inset-0 flex flex-col items-center justify-center min-h-screen w-full z-50 px-6 text-center"
            style={{ backgroundColor: "#000000", color: "white" }}
          >
            <p style={{ fontSize: "clamp(18px, 3vh, 24px)", maxWidth: 420 }}>
              No pudimos cargar tu solicitud. Puedes intentarlo de nuevo o volver al inicio.
            </p>
            <div style={{ display: "flex", gap: 16, marginTop: 24 }}>
              <button
                type="button"
                onClick={() => getFlowCredit()}
                style={{ padding: "10px 24px", borderRadius: 24, background: "#6C4CF1", color: "white" }}
              >
                Reintentar
              </button>
              <button
                type="button"
                onClick={() => {
                  cleanIndexDB();
                  navigate("/");
                }}
                style={{ padding: "10px 24px", borderRadius: 24, border: "1px solid white", color: "white" }}
              >
                Volver al inicio
              </button>
            </div>
          </div>
        ) : isStepLoading ? (
          <>
            <Fragment>
              <div
                className="fixed inset-0 flex items-center justify-center min-h-screen w-full z-50"
                style={{
                  backgroundColor: "#000000",
                  color: "white",
                  overflow: "hidden",
                }}
              >
                <canvas
                  ref={starsRef}
                  className="fixed inset-0 w-full h-full pointer-events-none"
                ></canvas>
                {/* Logo superior izquierda - solo desktop */}
                {!isMobile && (
                  <div
                    style={{
                      backgroundColor: "#29214F",
                      borderTopRightRadius: "50px",
                      borderBottomRightRadius: "50px",
                      width: "187px",
                      height: "62px",
                      position: "absolute",
                      left: 0,
                      top: 40,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      padding: "6px 20px 6px 0px",
                    }}
                  >
                    <GalileIcon
                      alt="Galilea"
                    // style={{
                    //   cursor: "pointer",
                    // }}
                    /* onClick={() => {
                    cleanIndexDB();
                    navigate("/");
                  }} */
                    />
                  </div>
                )}

                {/* Texto lateral izquierdo - solo desktop */}
                {!isMobile && (
                  <div
                    class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
                    <div class="flex flex-row items-center justify-center gap-4 mr-2">
                      <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                        <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                          alt="colombia fintech" />
                      </div>

                      <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                        <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                          alt="Superintendencia de Industria y Comercio" />
                      </div>
                    </div>
                    <span
                      class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
                      Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
                      Colombia con NIT: 901.582.748-5
                    </span>

                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "-webkit-fill-available",
                  }}
                >
                  <AnimationComponent
                    animationUrl="/animations/solicitudNave.riv"
                    width={
                      isMobile
                        ? "clamp(20rem,25vw,30rem)"
                        : "clamp(15rem,25vw,30rem)"
                    }
                    height={
                      isMobile
                        ? "clamp(25rem,60vh,45rem)"
                        : "clamp(25rem,55vh,45rem)"
                    }
                    heightContainer={
                      isMobile ? "15rem" : "clamp(25rem,55vh,45rem)"
                    }
                    isDesktop={!isMobile}
                    stateMachines={["machineSolicitud"]}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      overflow: "auto",
                    }}
                  >
                    <span
                      style={{
                        textAlign: "center",
                        width: "400px",
                        fontSize: "clamp(20px, 3vh, 25px)",
                        display: "inline-block",
                        animation: "fadeText 3s ease-in-out infinite",
                      }}
                    >
                      <div>
                        {texts[textIndex]}
                      </div>
                    </span>
                    <span
                      style={{
                        textAlign: "center",
                        width: "300px",
                        fontSize: "25px",
                      }}
                    ></span>
                  </div>
                </div>
              </div>
            </Fragment>
          </>
        ) : isFinishPass ? (
          <>
            <Fragment>
              <div
                className="fixed inset-0 flex items-center justify-center min-h-screen w-full z-50"
                style={{
                  backgroundColor: "#000000",
                  color: "white",
                  overflow: "hidden",
                }}
              >
                <canvas
                  ref={starsRef}
                  className="fixed inset-0 w-full h-full pointer-events-none"
                ></canvas>
                {!isMobile && (
                  <div
                    style={{
                      backgroundColor: "#29214F",
                      borderTopRightRadius: "50px",
                      borderBottomRightRadius: "50px",
                      width: "187px",
                      height: "62px",
                      position: "absolute",
                      left: 0,
                      top: 40,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      padding: "6px 20px 6px 0px",
                    }}
                  >
                    <GalileIcon
                      alt="Galilea"
                    // style={{
                    //   cursor: "pointer",
                    // }}
                    /* onClick={() => {
                    cleanIndexDB();
                    navigate("/");
                  }} */
                    />
                  </div>
                )}

                {!isMobile && (
                  <div
                    class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
                    <div class="flex flex-row items-center justify-center gap-4 mr-2">
                      <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                        <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                          alt="colombia fintech" />
                      </div>

                      <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                        <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                          alt="Superintendencia de Industria y Comercio" />
                      </div>
                    </div>
                    <span
                      class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
                      Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
                      Colombia con NIT: 901.582.748-5
                    </span>

                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "-webkit-fill-available",
                  }}
                >
                  <AnimationComponent
                    animationUrl="/animations/galileaAterrizaje.riv"
                    width={
                      isMobile
                        ? "clamp(27rem, 25vw, 30rem)"
                        : "clamp(15rem, 40vw, 60rem)"
                    }
                    height={
                      isMobile
                        ? "clamp(34rem, 25vh, 30rem)"
                        : "clamp(25rem, 80vh, 76rem)"
                    }
                    heightContainer={
                      isMobile ? "35rem" : "clamp(25rem, 80vh, 76rem)"
                    }
                    isDesktop={!isMobile}
                    stateMachines={["rocketLanding"]}
                    artboard={"rocketLanding"}
                    animations={["rocketLanding"]}
                    pointerEvents={"none"}
                  />
                </div>
              </div>
            </Fragment>
          </>
        ) : (
          <>
            <Fragment>
              {isMobile ? (
                <div
                  className="flex flex-col relative w-full"
                  style={{
                    backgroundColor: "#000000",
                    backgroundSize: currentStep === 5 && "cover",
                    backgroundRepeat: currentStep === 5 && "no-repeat",
                    color: "white",
                    height: "100dvh",
                    overflow: "hidden",
                  }}
                >
                  <canvas
                    ref={starsRef}
                    className="fixed inset-0 w-full h-full pointer-events-none"
                  ></canvas>
                  <div
                    className="flex md:hidden sticky top-0"
                    style={{
                      margin: "16px",
                      paddingLeft: "30px",
                    }}
                  >
                    {currentStep !== 5 && (
                      <ProgressBarComponent
                        iconStart={
                          <AnimationComponent
                            animationUrl="/animations/nave_galilea.riv"
                            rotateValue={"90deg"}
                            width={"3.5rem"}
                            height={"3.5rem"}
                            heightContainer={"3.5rem"}
                            isDesktop={isMobile}
                          />
                        }
                        iconEnd={
                          <AnimationComponent
                            animationUrl="/animations/planeta_galilea.riv"
                            width={"3.5rem"}
                            height={"3.5rem"}
                            isDesktop={isMobile}
                          />
                        }
                        totalSteps={totalSteps}
                        currentStep={currentStep}
                        stepTitles={stepTitles}
                        hiddenIconStart={hiddenIconStart}
                      />
                    )}
                  </div>

                  <div
                    className="flex-1 overflow-y-auto relative z-1"
                    style={{
                      overflowX: "hidden",
                    }}
                  >
                    {currentStep === 1 && (
                      <DatosPersonalesForm
                        onStepChange={handleStepChange}
                        currentStep={currentStep}
                        currentStepGeneral={currentStep}
                        stepTitlesGeneral={stepTitles}
                      />
                    )}
                    {currentStep === 2 && (
                      <DatosOfertaForm
                        onStepChange={handleStepChange}
                        currentStep={currentStep}
                        currentStepGeneral={currentStep}
                        stepTitlesGeneral={stepTitles}
                        isDesktop={false}
                      />
                    )}
                    {currentStep === 3 && (
                      <DatosFlowConnectBank
                        onStepChange={handleStepChange}
                        currentStep={currentStep}
                        currentStepGeneral={currentStep}
                        stepTitlesGeneral={stepTitles}
                      />
                    )}
                    {/* {currentStep === 4 && (
                    <DatosBancariosForm
                      onStepChange={handleStepChange}
                      currentStep={currentStep}
                      currentStepGeneral={currentStep}
                      stepTitlesGeneral={stepTitles}
                    />
                  )} */}
                    {currentStep === 4 && (
                      <DatosOtp
                        onStepChange={handleStepChange}
                        currentStep={currentStep}
                        currentStepGeneral={currentStep}
                        stepTitlesGeneral={stepTitles}
                      />
                    )}
                    {currentStep === 5 && (
                      <BienvenidoPage
                        onStepChange={handleStepChange}
                        currentStep={currentStep}
                        currentStepGeneral={currentStep}
                        stepTitlesGeneral={stepTitles}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div
                  className="min-h-screen flex flex-col relative w-full"
                  style={{
                    backgroundColor: "#000000",
                    color: "white",
                    overflow: "hidden",
                    backgroundSize:
                      currentStep === 5 && (!isMobile ? "100%" : "150%"),
                    backgroundRepeat: currentStep === 5 && "no-repeat",
                  }}
                >
                  <canvas
                    ref={starsRef}
                    className="fixed inset-0 w-full h-full pointer-events-none"
                  ></canvas>
                  <div
                    style={{
                      backgroundColor: "#29214F",
                      borderTopRightRadius: "50px",
                      borderBottomRightRadius: "50px",
                      width: "187px",
                      height: "62px",
                      position: "absolute",
                      left: 0,
                      top: 40,
                      display: "flex",
                      justifyContent: "flex-end",
                      padding: "6px 20px 6px  0px",
                    }}
                  >
                    <GalileIcon
                      alt="Galilea"
                    // style={{
                    //   cursor: "pointer",
                    // }}
                    /* onClick={() => {
                    cleanIndexDB();
                    navigate("/");
                  }} */
                    />
                  </div>

                  <div
                    class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
                    <div class="flex flex-row items-center justify-center gap-4 mr-2">
                      <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                        <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                          alt="colombia fintech" />
                      </div>

                      <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                        <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                          alt="Superintendencia de Industria y Comercio" />
                      </div>
                    </div>
                    <span
                      class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
                      Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
                      Colombia con NIT: 901.582.748-5
                    </span>

                  </div>
                  {currentStep !== 5 && (
                    <ProgressBarComponent
                      iconStart={
                        <AnimationComponent
                          animationUrl="/animations/nave_galilea.riv"
                          rotateValue={"90deg"}
                          width={"clamp(5rem, 4vw, 20rem)"}
                          height={"clamp(5rem, 4vw, 20rem)"}
                          isDesktop={!isMobile}
                        />
                      }
                      iconEnd={
                        <AnimationComponent
                          animationUrl="/animations/planeta_galilea.riv"
                          width={"clamp(2.5rem,5vw,4.5rem)"}
                          height={"clamp(2.5rem,5vw,4.5rem)"}
                          isDesktop={!isMobile}
                        />
                      }
                      totalSteps={totalSteps}
                      currentStep={currentStep}
                      isDesktop={true}
                      stepTitles={stepTitles}
                      hiddenIconStart={hiddenIconStart}
                    />
                  )}
                  {currentStep !== 5 && (
                    <div
                      style={{
                        position: "absolute",
                        top: "clamp(80px, 6vw, 30px)",
                        left: "400px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <div style={{ fontSize: "14px", color: "#BEBCC2" }}>
                        <div
                          className="text-sm mb-1.5"
                          style={{ color: "#c8cbda" }}
                        >
                          Paso {currentStep} de {stepTitles.length}
                        </div>
                      </div>
                      <div className="font-bold2" style={{ fontSize: "18px" }}>
                        {stepTitles && stepTitles[currentStep - 1]}
                      </div>
                    </div>
                  )}
                  <div style={getContainerStyle()}>
                    <div
                      className="flex-1 overflow-y-auto relative z-10"
                      style={{
                        overflowX: "hidden",
                        height: "-webkit-fill-available",
                        width: "-webkit-fill-available",
                        scrollbarWidth: "none",
                      }}
                    >
                      {currentStep === 1 && (
                        <DatosPersonalesForm
                          onStepChange={handleStepChange}
                          currentStep={currentStep}
                          currentStepGeneral={currentStep}
                          stepTitlesGeneral={stepTitles}
                          isDesktop={true}
                        />
                      )}
                      {currentStep === 2 && (
                        <DatosOfertaForm
                          onStepChange={handleStepChange}
                          currentStep={currentStep}
                          currentStepGeneral={currentStep}
                          stepTitlesGeneral={stepTitles}
                          isDesktop={true}
                        />
                      )}
                      {currentStep === 3 && (
                        <DatosFlowConnectBank
                          onStepChange={handleStepChange}
                          currentStep={currentStep}
                          currentStepGeneral={currentStep}
                          stepTitlesGeneral={stepTitles}
                          isDesktop={true}
                        />
                      )}
                      {/* {currentStep === 4 && (
                      <DatosBancariosForm
                        onStepChange={handleStepChange}
                        currentStep={currentStep}
                        currentStepGeneral={currentStep}
                        stepTitlesGeneral={stepTitles}
                        isDesktop={true}
                      />
                    )} */}
                      {currentStep === 4 && (
                        <DatosOtp
                          onStepChange={handleStepChange}
                          currentStep={currentStep}
                          currentStepGeneral={currentStep}
                          stepTitlesGeneral={stepTitles}
                          isDesktop={true}
                        />
                      )}
                      {currentStep === 5 && (
                        <BienvenidoPage
                          onStepChange={handleStepChange}
                          currentStep={currentStep}
                          currentStepGeneral={currentStep}
                          stepTitlesGeneral={stepTitles}
                          isDesktop={true}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}
              <FloatingWhatsApp
                show={currentStep >= 2 && currentStep < 5}
                phone="3124008320"
                message={`Hola, estoy en el paso ${currentStep} de mi solicitud y necesito soporte.`}
              />

              <style>
                {`
              .degraded-border {
                position: fixed;
                right: 0;
                bottom: 0;
                height: 80vh;
                background-color: transparent;
                border-top-left-radius: 150px;
                border-left: 0.1px solid #575684;
                overflow: hidden;
              }
              .degraded-border2 {
                position: fixed;
                width: 80vh;
                background-color: transparent;
                border-top-left-radius: 150px;
                border-top: 0.1px solid #575684;
                overflow: hidden;
              }

              .degraded-border2::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                height: 1.6px;
                width: 100%;
                background:linear-gradient(90deg, #575684 50.30%, #14141E 80.30%, transparent 14.40%);
              }

              .degraded-border::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 1.6px;
                height: 100%;
                background: linear-gradient(190deg, #575684 70.70%, #786E9900 70.30%);
              }
            `}
              </style>
            </Fragment>
          </>
        )}
      </Fragment>
    </AlertProvider>
  );
}
